import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/products`;

// CREATE =>  POST: add a new product to the server
export function createProduct(product) {
    return axios.post(API_URL, { ...product });
}

// READ
export function getAllProducts() {
    return axios.get(API_URL);
}

export function getPaginatedProducts(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getProductById(productId) {
    return axios.get(`${API_URL}/${productId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the product on the server
export function updateProduct(productId, product) {
    return axios.put(`${API_URL}/${productId}`, { ...product });
}


// DELETE => delete the product from the server
export function deleteProduct(productId) {
    return axios.delete(`${API_URL}/${productId}`);
}
